module.exports = __webpack_public_path__ + "static/n11sh1.f1b6cca9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/n11sh1.jpg
// module id = 431
// module chunks = 35783957827783